import { render, staticRenderFns } from "./RecordDeleteDialogue.vue?vue&type=template&id=4d8bc2f6&"
import script from "./RecordDeleteDialogue.vue?vue&type=script&lang=js&"
export * from "./RecordDeleteDialogue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports